import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectorItem } from '@app/component/selector/selector.component';
import { Currency } from '@app/model/currency';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';
import { UserService } from '@app/service/user-service/user.service';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { DeLoanOptionService } from '@app/service/de-loan-option/de-loan-option.service';

@Component({
  selector: 'app-de-confirm-tokenized-payment',
  templateUrl: './de-confirm-tokenized-payment.component.html',
  styleUrls: [
    '../../../route/page-shared.css',
    './de-confirm-tokenized-payment.component.scss',
  ],
})
export class DeConfirmTokenizedPaymentComponent extends RouteComponent {
  navigationInProgress = false;
  totalCheckoutValue: Currency = null;
  merchantName = '';
  selectorItems: SelectorItem[] = null;
  modalActive: boolean;
  currentLoanTermsStr: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected headerService: HeaderService,
    protected stateService: StateService,
    protected userService: UserService,
    private valuePipe: ValuePipe,
    private loanOptionService: DeLoanOptionService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    this.navigationInProgress = false;
    this.totalCheckoutValue = this.state.totalCheckoutValue;
    this.merchantName = this.state.checkoutCustomizations.merchantName;
    this.prepareModalInformation();
  }

  async handleCtaClick() {
    this.navigationInProgress = true;
    try {
      const resp = await this.userService.confirmTokenizedPayment();
      if (resp.success) {
        await this.navigate();
      }
    } catch (err) {
      this.handleError(err);
    }
    this.navigationInProgress = false;
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }

  prepareModalInformation(): void {
    this.selectorItems = [
      {
        tab: 'Ihr Kauf',
        title: 'Zusammenfassung',
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: this.stateService.getCustomTaxTypeText(
          `Gesamtbetrag inkl. MwSt: ${this.valuePipe.transform(
            this.state.totalCheckoutValue
          )}`,
          this.state.checkoutCustomizations
        ),
      },
    ];

    if (
      this.state.loanOptions &&
      this.state.loanOptions.length > 0 &&
      this.state.loanOptions[0]?.termId
    ) {
      const selectedLoanOption = this.state.loanOptions[0];

      this.currentLoanTermsStr = this.loanOptionService.buildLoanTermsString(
        selectedLoanOption,
        this.state.totalCheckoutValue
      );

      this.selectorItems = [
        ...this.selectorItems,
        {
          tab: 'Zahlungsbedingungen',
          title: 'Bedingungen für den Kauf auf Raten',
          descriptions: [{ text: this.currentLoanTermsStr }],
          links: [
            {
              text: 'Bedingungen für Teilzahlungen',
              onClick: () =>
                this.openURLinNewWindow(selectedLoanOption.loanTermsURL),
            },
            {
              ...(this.state.checkoutCustomizations.merchantTermsUrl !== null &&
                this.state.checkoutCustomizations.merchantName !== null && {
                  text: this.stateService.getCustomTermsUrlText(
                    this.state.checkoutCustomizations.merchantName + ' AGB',
                    this.state.checkoutCustomizations
                  ),
                  onClick: () =>
                    this.openURLinNewWindow(
                      this.state.checkoutCustomizations.merchantTermsUrl
                    ),
                }),
            },
            {
              ...(this.state.market === Market.AT && {
                text: 'Europäische Standardinformationen für Kreditierungen nach dem Verbraucherkreditgesetz',
                onClick: () =>
                  this.openURLinNewWindow(selectedLoanOption.secciURL),
              }),
            },
          ],
        },
      ];
    }
  }

  openURLinNewWindow(url: string): void {
    window.open(url, '_blank');
  }

  deactivateModal(): void {
    this.modalActive = false;
  }
}
